interface IResetUpdatedRecordsRequest {
    id: string
    isUpdated: boolean
}

export const useResetUpdatedRecords = () => {
    // const { invalidateUpdatedRecords } = useInvalidateUnfinishedRecords()

    // Disable this PATCH temporarily
    // const resetUpdatedRecordsMutation = useAppMutation<void, Error, IResetUpdatedRecordsRequest[]>({
    //     mutationFn: (data) =>
    //         createInstance({
    //             url: '/controller-logs/reset-updated',
    //             method: 'PATCH',
    //             data,
    //         }),
    //     onSuccess: async () => {
    //         await invalidateUpdatedRecords()
    //     },
    // })

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const handleResetUpdatedRecords = (_payload: IResetUpdatedRecordsRequest[]) => {
        // if (payload.length === 0) {
        // }
        // resetUpdatedRecordsMutation.mutate(payload)
    }

    return { handleResetUpdatedRecords }
}
